import React from 'react';
import { connect } from 'react-redux';

import {
  updateResult,
  toggleSlideLeave,
  toggleSlideStatus,
  exploreToggle,
} from '../actions';

const ConnectedRadio = props => {
  const {
    options,
    updateResult,
    results_key,
    slideIndex,
    fullpageApi,
    toggleSlideLeave,
    toggleSlideStatus,
    exploreToggle,
  } = props;

  const onChange = e => {
    toggleSlideLeave();

    toggleSlideStatus(slideIndex);
    updateResult({ results_key: results_key, value: e.target.value });

    e.persist();

    const timer = setTimeout(() => {
      if (slideIndex == 0) {
        if (e.target.value == 'no') {
          fullpageApi.moveTo(5);
          exploreToggle();
        } else {
          fullpageApi.moveSectionDown();
        }
      } else {
        fullpageApi.moveSectionDown();
      }
      clearTimeout(timer);
    }, 150);
  };

  return (
    <form className="form--split-section">
      {options.map(({ label, value }) => (
        <div
          key={value}
          className="form-item form-item--tool form-item--checkbox"
        >
          <input
            type="radio"
            name={label}
            id={value}
            value={value}
            checked={props[results_key] === value}
            className="form-check-input"
            onChange={onChange}
          />
          <label className="form-item__label-question" htmlFor={value}>
            <span className="label">{label}</span>
          </label>
        </div>
      ))}
    </form>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    [ownProps.results_key]: state[ownProps.results_key],
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateResult: result => dispatch(updateResult(result)),
    toggleSlideLeave: () => dispatch(toggleSlideLeave()),
    exploreToggle: () => dispatch(exploreToggle()),
    toggleSlideStatus: result => dispatch(toggleSlideStatus(result)),
  };
};

const Radio = connect(mapStateToProps, mapDispatchToProps)(ConnectedRadio);

export default Radio;
